import { render } from "./TutorTabComponent.vue?vue&type=template&id=9fa6c188"
import script from "./TutorTabComponent.vue?vue&type=script&lang=js"
export * from "./TutorTabComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__